import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-one-lesson-six-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['./_guide.component.css']
})
export class UnitOneLessonSixGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 1, Lesson 6 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 6: Work Maturity Skills";

    doPrint(): void {
        window.print();
    }
    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
